
import React from 'react';
import { FacilityOrderTemplateNewFlowPortalNoteModalTemplate } from 'themes/application/facility-order-new-flow/components';
import { observer } from 'mobx-react';
import { setCurrentView } from 'core/utils';
import { FacilityOrderTemplateNewFlowPortalNoteModalStore } from 'application/facility-order-new-flow/stores';

@setCurrentView((rootStore, componentProps) => new FacilityOrderTemplateNewFlowPortalNoteModalStore(rootStore, componentProps), 'facilityOrderTemplateNewFlowPortalNoteModalStore')
@observer
class FacilityOrderTemplateNewFlowPortalNoteModal extends React.Component {
    render() {
        return <FacilityOrderTemplateNewFlowPortalNoteModalTemplate {...this.props} />
    }
}

export default FacilityOrderTemplateNewFlowPortalNoteModal;
